// extracted by mini-css-extract-plugin
export default {"root":"UggREJ9xTW","link":"AeANu1tSiU"};